import { MeetingResponse } from 'api/meedioBackend/types';

export const buildRoomUrl = (identifier: string): string => `${window.location.origin}/rooms/${identifier}`;

export const getMeetingInviteUrl = (meeting: MeetingResponse): string => {
  const identifier = meeting.alias ?? meeting.matrix_room_id;
  return buildRoomUrl(identifier);
};
